import legal from './legal.json';
import type { LText } from '../hooks/useSiteContent';

/** Rechtstexte: pro Sprache eine Liste von Abschnitten.
 *  Im Text trennt eine Leerzeile Absätze, ein einfacher Zeilenumbruch erzeugt eine neue Zeile. */
export interface LegalSection { heading: string; text: string; }
export interface LegalContent {
  overline: LText;
  title: LText;
  sections: { de: LegalSection[]; en: LegalSection[]; ar: LegalSection[] };
}

export type LegalKey = 'page_impressum' | 'page_datenschutz' | 'page_agb';

export const LEGAL_DEFAULTS: Record<LegalKey, LegalContent> = legal;
